import React from 'react';
import { RadioGroup } from '@atlaskit/radio';
import type { Props } from './types.tsx';

const RadioGroupEdit = (props: Props) => {
	const { value, options, onChange, isInvalid, isDisabled = false, ...fieldProps } = props;
	return (
		<RadioGroup
			{...fieldProps}
			// radio group component handles undefined and null differently, pay attention when change value property
			value={value === null ? value : value?.value}
			options={options}
			isDisabled={isDisabled}
			onChange={(e) =>
				onChange(options.find((option) => option.value === e?.target?.value) || null)
			}
			isInvalid={isInvalid}
		/>
	);
};

export default RadioGroupEdit;
